var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.show
      ? _c(
          "div",
          {
            staticClass: "modal",
            on: {
              click: function($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                _vm.closeModal($event)
              }
            }
          },
          [
            _c(
              "div",
              { staticClass: "modal__content" },
              [
                _vm._t("default", [
                  _c("div", { staticClass: "modal__inner" }, [
                    _c(
                      "div",
                      { staticClass: "modal__msg" },
                      [
                        _vm.title
                          ? _c("h1", [_vm._v(_vm._s(_vm.title))])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._t("msg", [
                          _c("p", { domProps: { innerHTML: _vm._s(_vm.msg) } })
                        ]),
                        _vm._v(" "),
                        _c("van-button", { attrs: { type: "danger" } }, [
                          _vm._v("危险按钮")
                        ])
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "modal-footer" },
                      [
                        _c(
                          "Button",
                          {
                            attrs: { customStyle: _vm.cancelbtnStyle },
                            on: { click: _vm.onCancel }
                          },
                          [_vm._v(_vm._s(_vm.cancelText))]
                        ),
                        _vm._v(" "),
                        _c(
                          "Button",
                          {
                            attrs: { customStyle: _vm.confirmbtnStyle },
                            on: { click: _vm.onConfirm }
                          },
                          [_vm._v(_vm._s(_vm.confirmText))]
                        )
                      ],
                      1
                    )
                  ])
                ])
              ],
              2
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Modal/Modal.vue?vue&type=template&id=47db75aa&
// module id = null
// module chunks = 